// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"65347abe","455":"6bd077f8","977":"955522bb"}[chunkId] + ".chunk.js";
};